import React from 'react';
import { FormStatus } from '../../types';

interface SubmitButtonProps {
  status: FormStatus;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ status }) => {
  return (
    <button
      type="submit"
      disabled={status === 'sending'}
      className={`
        w-full py-3 px-6 rounded-full transition-colors
        ${status === 'sending' 
          ? 'bg-gray-400 cursor-not-allowed' 
          : 'bg-orange-500 hover:bg-orange-600'
        }
        text-white relative
      `}
    >
      {status === 'sending' ? 'Envoi en cours...' : 'Envoyer'}
    </button>
  );
};

export default SubmitButton;